import React from "react";
import styled from "styled-components";

const Container = styled.span`
    cursor: pointer;
    text-decoration: underline;
    color: #4268ff;

    transition: 100ms;
    &:hover {
        opacity: 0.7;
        transition: 200ms;
        text-decoration: none;
    }
`;

export type LinkButtonProps = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
    onClick?: () => void;
};

export function LinkButton(props: LinkButtonProps) {
    return (
        <Container onClick={props.onClick} className={props.className} style={props.style}>
            {props.children}
        </Container>
    );
}
